import React from 'react';
import { connect } from 'react-redux';
import Scenes from '../../../components/scenes/scenes';
import styles from './home.module.scss';
import StarList from '../starList/starList';
import StarInstruction from '../starInstruction/starInstruction';
import { Switch, Redirect, Route } from 'react-router-dom';
import common from '../../../common/common';
import LexueNoticeModal from '../../../components/Modal/LexueNoticeModal';
import { getLexueNotice } from '../../../services/lexueNotice';
import { Commun } from '../../../utils/axios';

const LEXUE_NOTICE_KEY = 'star_lexue_notice_done';

class Home extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      lexueNoticeVisible: false,
      lexueNotice: null,
    };
    this.hasCheckedLexueNotice = false;
  }

  componentDidMount() {
    Commun.get(`${common.userApiPrefix}/simple-info`).then(res => {
      if (!res) return;
      this.props.dispatch({
        type: 'SET_USERINFO',
        payload: {
          userInfo: res,
        },
      });
      this.hasCheckedLexueNotice = false;
      this.showLexueNotice(res);
    }).catch(error => {
      console.log('首页获取用户信息失败', error);
    });
  }

  showLexueNotice = (userInfo = this.props.userInfo) => {
    const mainOrgId = userInfo?.mainOrgId;
    if (!mainOrgId || this.hasCheckedLexueNotice || !common.isLexue(mainOrgId)) return;
    try {
      if (window.sessionStorage.getItem(LEXUE_NOTICE_KEY)) return;
    } catch (e) {}
    this.hasCheckedLexueNotice = true;
    getLexueNotice().then(res => {
      if (!this.hasNoticeContent(res)) {
        console.log('获取乐学首页公告失败或无有效文案', res);
        return;
      }
      this.openLexueNotice(res);
    }).catch(error => {
      console.log('获取乐学首页公告失败', error);
    });
  };

  hasNoticeContent = (notice) => {
    if (!notice) return false;
    const title = (notice.title || '').trim();
    const content = (notice.content || '').trim();
    return Boolean(title || content);
  };

  openLexueNotice = (notice) => {
    try {
      if (window.sessionStorage.getItem('star_lexue_notice_done')) return;
    } catch (e) {}
    this.setState({
      lexueNoticeVisible: true,
      lexueNotice: notice,
    });
  };

  closeLexueNotice = () => {
    try {
      window.sessionStorage.setItem('star_lexue_notice_done', '1');
    } catch (e) {}
    this.setState({
      lexueNoticeVisible: false,
      lexueNotice: null,
    });
  };

  render() {
    const { lexueNoticeVisible, lexueNotice } = this.state;
    return (
      <div className={styles.mHome}>
        <Switch>
          <Redirect exact from='/m' to={{pathname: '/m/scenes', search: window.location.search}} />
          <Route
            exact
            path="/m/scenes"
            render={(routeProps) => (
              <>
                <Scenes shell="mobile" {...routeProps} />
                <LexueNoticeModal
                  visible={lexueNoticeVisible}
                  title={lexueNotice?.title}
                  content={lexueNotice?.content}
                  onOk={this.closeLexueNotice}
                  onCancel={this.closeLexueNotice}
                />
              </>
            )}
          />
          <Route exact path="/m/starList" component={StarList} />
          <Route exact path="/m/starInstruction" component={StarInstruction} />
          <Route render={() => (<p style={{ position: 'absolute', left: '50%', top: '50%', transform: 'translateX(-50%) translateY(-50%)', fontSize: '50px', color: '#ccc' }} >404</p>)} />
        </Switch>
      </div>
    )
  }
}
const mapStateToProps = state => ({
  userInfo: state.common.userInfo,
});

export default connect(mapStateToProps)(Home);
